import {CustomFieldGroup} from 'custom-field/CustomFieldDefinitionTypes';
import {allRoutes} from 'custom-field/CustomFieldRoutes';
import EditRole from 'management/role/EditRole';
import { getRole } from 'management/role/RoleService';
import React, {ReactElement} from 'react';
import ReportColumnConfigurationView from 'report/ReportColumnConfigurationView';
import ReportColumnConfigurationContainer from 'report/ReportConfiguationContainer';
import ReportConfigurationList from 'report/ReportConfigurationList';
import ReportOrderConfigurationView from 'report/ReportOrderConfigurationView';
import ReportService from 'report/ReportService';
import RouteDefinition from 'routes/RouteDefinition';

const reportService = new ReportService();
const ReportColumnView = () : ReactElement => <ReportColumnConfigurationContainer viewType={ReportColumnConfigurationView}/>;
const ReportOrderView = () : ReactElement  => <ReportColumnConfigurationContainer viewType={ReportOrderConfigurationView}/>;

const routes: RouteDefinition[] = [
  {
      name: 'Report configuration',
      path: '/admin/report-configuration',
      commandAccess: 'UpdateReportConfiguration',
      Component: ReportConfigurationList
  },
  {
    name: async (params: {reportCode: string}): Promise<string> => {
      const descriptor = await reportService.readDescriptor({reportCode: params.reportCode});
      return descriptor.name;
    },
    path: '/admin/report-configuration/:reportCode',
    commandAccess: 'UpdateReportConfiguration',
  },
  {
      name: 'Columns',
      path: '/admin/report-configuration/:reportCode/columns',
      commandAccess: 'UpdateReportConfiguration',
      Component: ReportColumnView
  },
  {
      name: 'Order',
      path: '/admin/report-configuration/:reportCode/order',
      commandAccess: 'UpdateReportConfiguration',
      Component: ReportOrderView
  },
  {
    name: 'Security',
    path: '/admin/security'
  },
  {
    name: 'Roles',
    path: '/admin/security/roles'
  },
  {
    name: async (params: {roleId: string}): Promise<string> => {
      const { data } = await getRole(Number(params.roleId));
      return data.name;
    },
    path: '/admin/security/roles/edit/:roleId',
    Component: EditRole,
    commandAccess: 'UpdateRole'
  },
  ...allRoutes('/admin/customer', CustomFieldGroup.CUSTOMER, true)
];

export default routes;
